import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HistoryTypeEnum {
    PastSurgicalHistory = 1 as any,
    SocialHistory = 2 as any,
    PalliativeHistory = 2 as any
}
class HistoryTypeClass extends EnumWithDescription<HistoryTypeEnum> {
    public readonly enum = HistoryTypeEnum;
    public readonly enumName: string = "HistoryTypeEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HistoryTypeEnum>> = new Map([
        [
            "PastSurgicalHistory",
            {
                value: HistoryTypeEnum.PastSurgicalHistory,
                name: "Past Surgical History"
            }
        ],
        [
            "SocialHistory",
            {
                value: HistoryTypeEnum.SocialHistory,
                name: "Social History"
            }
        ],
        [
            "PalliativeHistory",
            {
                value: HistoryTypeEnum.PalliativeHistory,
                name: "Palliative History"
            }
        ]
    ]);
}

export const HistoryType = new HistoryTypeClass();
